import SlideshowControl from './slideshow-control'

export default SlideshowControl
